import { Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import { OfferService } from 'src/app/core/services/offer.service';
import { SesionService } from 'src/app/core/services/sesion.service';
import { Meta, Title } from '@angular/platform-browser';
import { MetatagsService } from 'src/app/core/services/metatags.service';
import { DataLayersService } from 'src/app/core/services/data-layers.service';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { RuntimeConfigService } from 'src/app/core/config/services/runtime-config.service';
import { FilterPanelValueChange } from 'src/app/shared/ui/organisms/filter-panel/filter-panel.component';
declare var $: any;

@Component({
    selector: 'app-filters',
    templateUrl: './filters.component.html',
    styleUrls: ['./filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FiltersComponent implements OnInit {

  public filterScroll: any;
  public filterView: any;
  public nameSesion: any; //Revisar
  public btnFilterM: boolean = true;
  public scroll: number = window.scrollY;
  public isBackDropFilter = false;
  public filterMobile = false;
  public monto = '0';
  public digital_option = false;
  cont_option_choose_cat = 0;
  cont_option_choose_subcat = 0;

  
  // Se incrementa en cada 'Limpiar filtros' y se usa como parte del track del @for de filtros,
  filtersResetKey = 0;

  constructor(
      private dataLayerService: DataLayersService, 
      public offer: OfferService, 
      private activateRoute: ActivatedRoute, 
      public sesion: SesionService, 
      public location: Location, private _title: Title,
      private _metaService: Meta, 
      public metaServ: MetatagsService, 
      public utilities: UtilitiesService, 
      private runtimeConfig: RuntimeConfigService) {
    this.cambiar_metadatos('', '');
    this.nameSesion = this.sesion.nameSession;
  }

  /**
   * Visibilidad de la tarjeta "buscador de categoría" (header-select + category-select), controlada
   * por el feature flag 'showCategoryFinder' del tenant activo.
   */
  get showCategoryFinder(): boolean {
    return this.runtimeConfig.isFeatureEnabled('showCategoryFinder');
  }

  /**
   * Misma condición que antes decidía si se pintaba el <option> placeholder del select de categoría.
   */
  get showCategoryPlaceholder(): boolean {
    return (1 > this.cont_option_choose_cat && this.sesion.isIdsession()) || (2 > this.cont_option_choose_cat && !this.sesion.isIdsession());
  }

  /**
   * Misma condición que antes decidía si el <option> placeholder de categoría estaba deshabilitado.
   */
  get categoryPlaceholderDisabled(): boolean {
    return !(1 > this.cont_option_choose_cat && this.sesion.isIdsession());
  }

  /**
   * Funcion que al hacer scroll valida si esta en un dispositivo mobile para mostrar el boton de filtros
   * y al hacer scroll hacia arriba mostrar este boton, si esta en dispositivo desktop valida si la caja de filtros
   * llego muy abajo para hacerla desaparecer
   */
  @HostListener('window:scroll')
  onScroll() {
    if (!this.isBackDropFilter) {
      // if (window.scrollY >= 160) {
      //   this.filterScroll = true;
      // } else {
      //   this.filterScroll = false;
      // }
      // if (window.innerWidth < 1440) {
      //   if ($('#body-market-place').outerHeight() - window.scrollY > 150) {
      //     this.filterView = false;
      //   } else {
      //     this.filterView = true;
      //   }
      // } else {
      //   if ($('#body-market-place').outerHeight() - window.scrollY > 450) {
      //     this.filterView = false;
      //   } else {
      //     this.filterView = true;
      //   }
      // }
      this.buttonFilerMobileView();
    }
  };

  /**
   * Funcion de inicio del componente que valida si el tamaño de la pantalla es mobile para mostrar el boton de filtros mobile
   * ademas inicializa los filtros
   */
  ngOnInit(): void {
    this.activateRoute.params.subscribe({
      next: (result: Params) => {
        setTimeout(() => {
          this.offer.categorySel = undefined;
          this.offer.subCategorySel = undefined;
          this.setUrl(result);
        }, 200)
      }
    });
    
    // if (window.innerWidth < 768) {
    //   this.filterMobile = true;
    // } else {
    //   this.filterMobile = false;
    // }
  }

  /**
   * Funcion que recibe los parametros de la url para comenzar a filtrar por categorias y sub-categorias
   * tambien inicializan los sleectores en la caja de filtros
   * @param params parametros de url
   */
  setUrl(params: Params) {
    if (params['category'] != undefined) {
      let categoryUrl = this.activateRoute.snapshot.paramMap.get('category')
      this.offer.categorySel = this.offer.categoriesActive.find((element: any) => { return element.url == categoryUrl });
      // categoriesActive puede no haber cargado aun (race condition con setCategories()); sin categoria no hay nada que preseleccionar.
      if (!this.offer.categorySel) {
        return;
      }
      let selectCategory = document.getElementById('sel-category');
      (selectCategory as HTMLSelectElement).value = this.offer.categorySel.id;
      let selectCategoryMobile = document.getElementById('sel-category-mob');
      (selectCategoryMobile as HTMLSelectElement).value = this.offer.categorySel.id;
      this.selectCategory((selectCategory as HTMLSelectElement), false)
      setTimeout(() => {
        if (params['subCategory'] != undefined && this.offer.categorySel != undefined) {
          let subCategoryUrl = this.activateRoute.snapshot.paramMap.get('subCategory')
          this.offer.subCategorySel = this.offer.categorySel.subcategories.find((element: any) => { return element.url == subCategoryUrl });
          if (!this.offer.subCategorySel) {
            return;
          }
          let selectSubCategory = document.getElementById('sel-subCat');
          (selectSubCategory as HTMLSelectElement).value = this.offer.subCategorySel.id;
          let selectSubCategoryMobile = document.getElementById('sel-subCat-mob');
          (selectSubCategoryMobile as HTMLSelectElement).value = this.offer.subCategorySel.id;
          this.selectSubCategory((selectSubCategory as HTMLSelectElement), false)
        }
      }, 200);
    }
  }

  /**
   * Fucnion que filtra las ofertas por categoria, si tiene sub-categorias habilita el campo, cambia la variable de la subcategoria,
   * llama funcion de seo, limpia los demas filtros, inicializa los filtros correspondientes y cambia el estado de la url del navegador
   * @param target Elemento html select para filtrar
   * @param navigate variable para saber si se cambian la url
   * @param search_box variable para ejecutar llamado seo
   */
  selectCategory(target: EventTarget | null, navigate: boolean = true, search_box?: boolean) {
    this.cont_option_choose_cat++;
    this.cleanFil();
    this.send_datalayer_user();
    this.offer.categorySel = undefined;
    this.offer.subCategorySel = undefined;
    let value = (target as HTMLSelectElement).value;
    this.filterBasic([]);
    this.offer.categorySel = this.offer.categoriesActive.find((element: any) => { return element.id == value });
    // El <select> puede no tener aun la opcion renderizada (categoriesActive llego tarde); sin match no hay categoria valida que procesar.
    if (!this.offer.categorySel) {
      return;
    }
    if (this.offer.categorySel.subcategories.length > 0) {
      this.offer.subCategories = this.offer.categorySel.subcategories.filter((element: any) => { return element.state == 1 });
    } else {
      this.offer.categorySel.filters;
      this.filterBasic(this.offer.categorySel.filters);
      this.offer.subCategories = [];
      // this.router.navigate(['/'])
    }
    this.cambiar_metadatos(this.offer.categorySel, 'categoria');
    if (search_box) {
      this.enviar_terminos_busqueda('categoria', this.offer.categorySel.name);
    }
    if (navigate) {
      if (this.sesion.sesionCookie) {
        // this.router.navigate(['/ofertas/' + this.offer.categorySel.url]);
        this.location.replaceState('/ofertas/' + this.offer.categorySel.url);
      } else {
        // this.router.navigate(['/categoria/' + this.offer.categorySel.url]);
        this.location.replaceState('/categoria/' + this.offer.categorySel.url);
      }
    }
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    this.offer.setFilterOffer();
  }

  /**
   * Función que envia el data layer user por cada nueva búsqueda
   */
  send_datalayer_user() {
    if (this.sesion.sesionCookie) {
      this.dataLayerService.dl_userId('.', 'logueado');
    }
    if (!this.sesion.sesionCookie) {
      this.dataLayerService.dl_userId(null, 'anonimo');
    }
  }

  /**
   * Fucnion que filtra las ofertas por sub-categoria, llama funcion de seo, limpia los demas filtros, inicializa los filtros correspondientes y cambia el estado de la url del navegador
   * @param target Elemento html select para filtrar
   * @param navigate variable para saber si se cambian la url
   * @param search_box variable para ejecutar llamado seo
   */
  selectSubCategory(target: EventTarget | null, navigate: boolean = true) {
    this.cont_option_choose_subcat ++;
    // Solo se reinician los filtros avanzados: cleanFil() borraba tambien la categoria y la lista
    // de subcategorias, dejando el panel vacio al elegir cualquier subcategoria.
    this.resetAdvancedFilters();
    this.offer.subCategorySel = undefined;
    this.filterBasic([]);
    let value = (target as HTMLSelectElement).value;
    if (!this.offer.categorySel) {
      this.offer.setFilterOffer();
      return;
    }
    this.offer.subCategorySel = this.offer.categorySel.subcategories.find((element: any) => { return element.id == value })
    // Placeholder u opcion sin match: se mantiene la categoria y se vuelve a su resultado.
    if (!this.offer.subCategorySel) {
      this.offer.setFilterOffer();
      return;
    }
    this.filterBasic(this.offer.subCategorySel.filters);
    this.cambiar_metadatos(this.offer.subCategorySel, 'subcategoria');
    this.enviar_terminos_busqueda('subcategoria', this.offer.subCategorySel.name);
    if (navigate) {
      if (this.sesion.sesionCookie) {
        // this.router.navigate(['/ofertas/' + this.offer.categorySel.url + '/' + this.offer.subCategorySel.url]);
        this.location.replaceState('/ofertas/' + this.offer.categorySel.url + '/' + this.offer.subCategorySel.url);
      } else {
        // this.router.navigate(['/categoria/' + this.offer.categorySel.url + '/' + this.offer.subCategorySel.url]);
        this.location.replaceState('/categoria/' + this.offer.categorySel.url + '/' + this.offer.subCategorySel.url);
      }
    }
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    this.offer.setFilterOffer();
  }

  /**
   * Funcion que recibe la lista de los filtros que estan configurados en la categoria o sub-categoria para mostrarlos
   * @param filtersSel Filtros de categoria o subcategoria
   */
  filterBasic(filtersSel: Array<any>) {
    this.offer.filtersSel = this.offer.filters.filter((element: any) => filtersSel.includes(element.id))
  }

  /**
   * Dispatcher único que recibe el evento normalizado de app-filter-panel ({id, value, type})
   * y reproduce los mismos efectos secundarios (analítica) que antes tenían rangeInput/checkInput/boolInput/textInput.
   * @param change evento emitido por el organismo de filtros
   */
  handleFilterValueChange(change: FilterPanelValueChange): void {
    switch (change.type) {
      case 'range':
        this.applyRangeFilter(change.id, change.value as number);
        break;
      case 'bool':
        this.applyBoolFilter(change.id, change.value as string);
        break;
      default: // 'check' | 'select' | 'text'
        this.offer.setFilterOffer(change.id, change.value);
    }
  }

  private applyRangeFilter(id: number, val: number): void {
    this.offer.setFilterOffer(id, val);
    this.monto = val.toString();
    if (this.offer.subCategorySel) {
      this.enviar_terminos_busqueda('subcategoria', this.offer.subCategorySel.name);
    } else {
      this.enviar_terminos_busqueda('categoria', this.offer.categorySel.name);
    }
  }

  private applyBoolFilter(id: number, val: string): void {
    this.offer.setFilterOffer(id, val);
    this.digital_option = !this.digital_option;
    if (this.offer.subCategorySel) {
      this.enviar_terminos_busqueda('subcategoria', this.offer.subCategorySel.name);
    } else {
      this.enviar_terminos_busqueda('categoria', this.offer.categorySel.name);
    }
  }


  /**
   * Reinicia unicamente los filtros avanzados (range/bool/check/text) conservando la categoria
   * y la subcategoria seleccionadas, para que el panel siga mostrando la seleccion del usuario.
   */
  private resetAdvancedFilters() {
    this.filtersResetKey++;
    this.offer.filtersSel = [];
    this.offer.filtersApply = [];
  }

  /**
   * Handler del boton 'Limpiar filtros': reinicia solo los valores de los filtros avanzados y
   * conserva la categoria y la subcategoria elegidas, junto con los campos de filtro que esa
   * seleccion muestra. Si todavia no hay categoria, se limpia todo el panel como antes.
   */
  cleanAdvancedFil() {
    this.dataLayerService.dl_eventoGA4_general('clean_search');
    if (!this.offer.categorySel) {
      this.cleanFil();
      return;
    }
    // Se conservan los mismos campos visibles: solo se recrean con su valor inicial.
    const visibleFilterIds = this.offer.filtersSel.map((element: any) => element.id);
    this.resetAdvancedFilters();
    this.filterBasic(visibleFilterIds);
    this.monto = '0';
    this.digital_option = false;
    this.offer.setFilterOffer();
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  /**
   * Funcion que limpia las variable y vuelve al estado inicial de los filtros.
   * Además envía un evento data layer de la limpieza demandada por el usuario.
   * @param accion para saber si llama al evento seo
   */
  cleanFil(accion?: string) {
    if (accion == 'limpiar') {
      this.dataLayerService.dl_eventoGA4_general('clean_search');
    }
    this.filtersResetKey++;
    this.offer.categorySel = undefined;
    this.offer.subCategorySel = undefined;
    this.offer.subCategories = [];
    this.offer.filtersSel = [];
    this.offer.filtersApply = [];
    this.cont_option_choose_cat = 0;
    this.cont_option_choose_subcat = 0;
    this.offer.setFilterOffer();
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  /**
   * Funcion que muestra o oculta la caja de filtros en version mobile
   */
  changeFilterView() {
    this.isBackDropFilter = !this.isBackDropFilter;
    $("html, body").animate({ scrollTop: 0 }, 500);
  }

  /**
  * Esta función maneja los cambios de metadata (metatitulos y metadescripción) y los titulos h1 que se muestran a medida que cambia de categoria.
  * @param datos En esta variable se almacena los datos de la categoria o subcategoria actual.
  * @param tipo La variable me define si los datos que entran son una categoria o una subcategoria.
  */
  cambiar_metadatos(datos: any, tipo: string) {
    if (datos.titulo && datos.titulo_movil) {
      this.offer.title_h1 = datos.titulo;
      this.offer.title_mobile_h1 = datos.titulo_movil;
      this._title.setTitle(datos.metatitulo);
      this._metaService.updateTag({ name: 'description', content: datos.metadescripcion });
    } else {
      this.offer.title_h1 = 'Descubre las oportunidades financieras de nuestros aliados: Créditos de vivienda, libre inversión, vehículos y créditos de microempresarios';
      this.offer.title_mobile_h1 = '¡Descubre oportunidades financieras a tu medida con Buscacrédito!';
      this._title.setTitle('Buscacrédito | Las mejores ofertas de créditos, inversión y más');
      this._metaService.updateTag({ name: 'description', content: 'Busca y compara múltiples ofertas de créditos y muchos productos financieros más! Desembolsos completamente online y preaprobaciones gratis.' });
    }

    // Cambiar las URL's canonicals
    const categoria = this.activateRoute.snapshot.paramMap.get('category');
    if (this.sesion.isIdsession()) {
      if (tipo == 'subcategoria' && datos) {
        this.metaServ.createCanonicaURL(`https://buscacredito.midatacredito.com/ofertas/${categoria}/${datos.url}`);
      } else {
        this.metaServ.createCanonicaURL(`https://buscacredito.midatacredito.com/ofertas/${categoria}`);
      }
    } else {
      if (tipo == 'subcategoria' && datos) {
        this.metaServ.createCanonicaURL(`https://buscacredito.midatacredito.com/categoria/${categoria}/${datos.url}`);
      } else {
        this.metaServ.createCanonicaURL(`https://buscacredito.midatacredito.com/categoria/${categoria}`);
      }
    }
  }

  /**
   * Función que sirve para el envio de data layers según los parametros de busqueda; que son la categoria, subcategoria, y filtros
   * El data layer que se utiliza para esta función es "search" y se envia por medio de la función dataLayerService.dl_eventoGA4_search
   * @param indice Variable que describe si es una categoria o una subcategoria lo que entra.
   * @param categoria Nombre de la categoria o subcategoria.
   */
  enviar_terminos_busqueda(indice: string, categoria: string) {
    if (indice == 'categoria') {
      if (categoria != 'Tarjetas de crédito') {
        this.dataLayerService.dl_eventoGA4_search(categoria, null, null, null, null, null);
      }
      if (categoria == 'Tarjetas de crédito') {
        if (this.monto == '0') { this.monto = '800000'; }
        this.dataLayerService.dl_eventoGA4_search('Tarjeta de crédito', null, this.digital_option, this.monto, 'Monto', null);
        this.monto = '0';
      }
    } else if (indice == 'subcategoria') {
      if (this.offer.subCategorySel.url == 'libre-inversion') {
        if (this.monto == '0') { this.monto = '0'; }
        this.dataLayerService.dl_eventoGA4_search('Créditos', 'Libre inversión', this.digital_option, this.monto, 'Monto', null);
      }
      if (this.offer.subCategorySel.url == 'vivienda') {
        if (this.monto == '0') { this.monto = '10000000'; }
        this.dataLayerService.dl_eventoGA4_search('Créditos', 'Vivienda', this.digital_option, this.monto, 'Tipo Vivienda', null);
      }
      if (this.offer.subCategorySel.url == 'vehiculo') {
        if (this.monto == '0') { this.monto = '500000'; }
        this.dataLayerService.dl_eventoGA4_search('Créditos', 'Vehículo', this.digital_option, this.monto, 'Monto', null);
      }
      if (this.offer.subCategorySel.url == 'libranza' || this.offer.subCategorySel.url == 'microempresarios' || this.offer.subCategorySel.url == 'compra-cartera') {
        this.dataLayerService.dl_eventoGA4_search('Créditos', this.offer.subCategorySel.url, null, null, null, null);
      }
      if (this.offer.categorySel.url != 'creditos') {
        this.dataLayerService.dl_eventoGA4_search(this.offer.categorySel.url, this.offer.subCategorySel.url, null, null, null, null);
      }
      this.monto = '0';
    }
  }

  /**
   * Funcion que valida el tamaño del dispositivo para saber si es mobile y mostrar el boton de filtros
   * para version mobile, tambien valida si esl dispositivo es IOS para que al hacer scroll hacia arriba
   * muestre el boton de filtros
   */
  buttonFilerMobileView() {
    if (window.innerWidth < 768) {
      if (this.utilities.iOS()) {
        if (this.scroll > window.scrollY) {
          this.btnFilterM = false;
        } else {
          this.btnFilterM = true;
        }
      } else {
        if (this.scroll > window.scrollY) {
          this.btnFilterM = true;
        } else {
          this.btnFilterM = false;
        }
      }
      this.scroll = window.scrollY;
    }
  }

}
